import React from 'react';
import { ObligationsDashboardMetrics } from './types';

interface Props {
  metrics: ObligationsDashboardMetrics | null;
  loading: boolean;
}

export const ObligationsMetricsCards: React.FC<Props> = ({ metrics }) => {
  return (
    <div className="stats-grid">
      <div className="stat-card">
        <span className="stat-label">On-Time Fulfillment Rate</span>
        <span className="stat-value" style={{ color: '#059669' }}>%{metrics?.on_time_fulfillment_rate ?? 0}</span>
        <span className="stat-sub">
          {(metrics?.verified_instances ?? 0) + (metrics?.pending_verification_instances ?? 0)} / {metrics?.total_instances ?? 0} Cycles
        </span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Verification Pass Rate</span>
        <span className="stat-value" style={{ color: '#2563eb' }}>%{metrics?.verification_pass_rate ?? 0}</span>
        <span className="stat-sub">{metrics?.verified_instances ?? 0} Verified Cycles</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Overdue Obligations</span>
        <span className="stat-value" style={{ color: (metrics?.overdue_instances ?? 0) > 0 ? '#dc2626' : '#64748b' }}>
          {metrics?.overdue_instances ?? 0}
        </span>
        <span className="stat-sub">Overdue fulfillment cycles</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Open & Pending Verification</span>
        <span className="stat-value" style={{ color: '#d97706' }}>{metrics?.open_instances ?? 0}</span>
        <span className="stat-sub">
          {metrics?.pending_verification_instances ?? 0} Pending Verification • {metrics?.active_waivers_count ?? 0} Waivers
        </span>
      </div>
    </div>
  );
};
